import { Component } from '@theme/component';
import { StandardEvents, ProductSelectEvent } from '@shopify/events';

/** Byter innehåll i rea-brickan när kunden väljer en annan variant. */
class HhReaBricka extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  /**
   * @param {ProductSelectEvent} event
   */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const newBricka = html.querySelector('hh-rea-bricka');
        if (newBricka) this.innerHTML = newBricka.innerHTML;
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[hh-rea-bricka] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('hh-rea-bricka')) {
  customElements.define('hh-rea-bricka', HhReaBricka);
}
